import player from "./player";
import userApi from "./userApi";
import ProductTracks from "./ProductTracks";
import ProductVideo from "./ProductVideo";
import { ProdState } from "./types";

(() => {
	let isInit = false;
	document.addEventListener("DOMContentLoaded", () => {
		init();
	});
	setInterval(() => {
		if (!isInit) {
			if (document.readyState === "complete") {
				init();
			}
		}
	}, 400);

	const init = () => {
		console.log("products DOMContentLoaded init");
		//@ts-ignore
		if (isInit === true) return false;
		//@ts-ignore
		isInit = true;

		const addToCart = (productId: string) => {
			const data = (<any>window).getProductData(productId);
			let isValid = true;
			if (Object.keys(data.services).length) {
				console.log("addToCart data", data.services);
				Object.keys(data.services).forEach((x) => {
					if (data.services[x].comment === "") {
						isValid = false;
						// triger required alert
						document
							.querySelector<HTMLFormElement>(
								`.jsProduct[data-id="${productId}"] .jsByOneClick`
							)
							?.click();
						return;
					}
				});
			}
			if (isValid) {
				(<any>window).cart.add(data);
			}
		};
		(<any>window).addToCart = addToCart;

		(<any>window).highligh = () => {
			//search highlighting
			if (location.search) {
				const productsTitles = document.querySelectorAll(
					".jsSearchHighlighting"
				);
				const keywords = location.search.split("?keyword=")[1];
				if (keywords) {
					const searchArr = keywords.split("&")[0].split("+");
					productsTitles.forEach((titleNode: any) => {
						let title = titleNode.innerText;
						// console.log('title' , titleNode);
						if (title.length > 2) {
							searchArr.forEach((searchWord) => {
								let title = titleNode.innerText;
								let initialWord = "";
								const searchWord2 =
									decodeURIComponent(searchWord);

								const wordIndex = titleNode.innerText
									.toLowerCase()
									.indexOf(searchWord2.toLowerCase());
								if (wordIndex > -1) {
									initialWord = title.substr(
										wordIndex,
										searchWord2.length
									);
									// console.log('initialWord' , initialWord);
									title = title.replace(
										initialWord,
										`<span class='highlighted'>${initialWord}</span>`
									);
									titleNode.innerHTML = title;
								}
							});
						}
					});
				}
			}
		};
		(<any>window).highligh();

		//

		localStorage.setItem("productViews", JSON.stringify([]));

		type State = {
			products: { [key: number]: ProdState };
			activeProductId: number;
			activeTrack: string;
		};
		(<any>window).globalState = {
			activeTrack: "",
			activeProductId: 0,
		};
		const main = {
			products: <{ [key: number]: any }>{},

			init: () => {
				// console.log("test_3");

				const items = [
					...document.querySelectorAll<HTMLElement>(`.jsProduct`),
					...document.querySelectorAll<HTMLElement>(`.jsFreemusic`),
				];

				items?.forEach((jsProduct) => {
					if (jsProduct.classList.contains("jsKindVideo")) {
						const prod = new ProductVideo(jsProduct);
						prod.init();
						main.products[prod.id] = prod;
					} else {
						const prod = new ProductTracks(jsProduct);
						prod.init();
						main.products[prod.id] = prod;
					}
				}); //jsProduct

				userApi.onChange();
				if ((<any>window).tippy) {
					(<any>window).tippy(
						document.querySelectorAll("[data-tippy-content]")
					);
				}
				if ((<any>window).highligh) {
					(<any>window).highligh();
				}
				if ((<any>window).mdc) {
					(<any>window).mdc.autoInit();
				}

				// player.init(jsProduct.querySelectorAll<HTMLElement>(`.jsProgressbar`) , jsProduct.querySelectorAll<HTMLElement>(`.jsProgressbar`))
			},

			// render: () => {
			// 	// alert("render_" + main.state.activeProductId);
			// 	Object.keys(main.state.products).forEach((prodId: any) => {
			// 		main.renderProduct(prodId);

			// 		// const jsPlayTrack = main.dom[prodId].querySelector(`.jsPlayList .jsPlayTrack[data-file="${main.state.activeTrack}"]`);
			// 	});
			// },
			// renderProduct: (prodId: number) => {
			//     const prodState = main.state.products[prodId];
			//     const jsProduct = main.dom[prodId]
			//     const activeTrack = main.state.activeTrack

			// 	Product.render(prodState , jsProduct , activeTrack)
			// },
		};
		main.init();

		(<any>window).productsMain = main;
	};
	//@ts-ignore
	window.init = init;
})();
export {};
